var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "right head-right" }, [
    _vm._m(0),
    _vm._v(" "),
    _c("div", { attrs: { id: "head-login" } }, [_c("login-btn")], 1),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { attrs: { id: "no-barrier" } }, [
      _c(
        "a",
        {
          attrs: { href: "javascript:void(0)", id: "wza", clickHide: "false" },
        },
        [_vm._v("无障碍")]
      ),
      _vm._v(" "),
      _c("span", { staticClass: "divider" }),
      _vm._v(" "),
      _c(
        "a",
        {
          attrs: { href: "javascript:void(0)", id: "ghb", clickHide: "false" },
        },
        [_vm._v("关怀版")]
      ),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }